import { Toaster as Sonner, ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      richColors
      theme="light"
      className="toaster group"
      style={
        {
          // Normal toast
          '--normal-bg': '#ffffff',
          '--normal-text': 'var(--foreground)',
          '--normal-border': 'var(--primary)',

          // Success toast - use primary teal colors
          '--success-bg': 'var(--primary)',
          '--success-text': '#ffffff',
          '--success-border': 'var(--primary-ocean-teal)',

          // Info toast - use primary blue colors
          '--info-bg': 'var(--primary-blue-light)',
          '--info-text': 'var(--foreground)',
          '--info-border': 'var(--primary-blue-mid)',

          // Warning toast - use yellow colors
          '--warning-bg': 'var(--primary-yellow-light)',
          '--warning-text': 'var(--foreground)',
          '--warning-border': 'var(--primary-yellow-mid)',

          // Error toast - use destructive color
          '--error-bg': 'var(--destructive)',
          '--error-text': '#ffffff',
          '--error-border': '#b33e36',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
